import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { setGAConfig } from '../utils';
import { useAppEnvironment } from './useAppEnvironment';
import { useTrackingUserParamsStore } from '@/modules/userTrackingParams';
import { useCommonStore } from '@/store';

/**
 * @description This hook is used to set the Google Analytics configuration.
 * It retrieves the tracking parameters from the user tracking store and the user ID from the common store.
 * It also determines the platform (web or PWA) and sets the Google Analytics configuration accordingly.
 */
export const useGAConfigHook = () => {
  const { stag, campaign_id, promo_id } = useTrackingUserParamsStore(
    useShallow((state) => ({
      stag: state.stag,
      campaign_id: state.campaign_id,
      promo_id: state.promo_id,
    }))
  );

  const user_id = useCommonStore.use.user()?.id;
  const platform = useAppEnvironment();

  useEffect(() => {
    setGAConfig({
      stag,
      campaign_id,
      promo_id,
      user_id,
      platform,
    });
  }, [stag, campaign_id, promo_id, user_id, platform]);
};
